import { Switch as RSwitch } from 'radix-ui';
import { cn } from '@/lib/utils';

export function Switch({
  checked,
  onCheckedChange,
  disabled,
  id,
  'aria-label': ariaLabel,
}: {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
}) {
  return (
    <RSwitch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'relative inline-flex h-[18px] w-8 touch:h-6 touch:w-11 shrink-0 cursor-pointer items-center rounded-full border border-border-strong bg-panel-2 transition-colors',
        'data-[state=checked]:border-accent data-[state=checked]:bg-accent disabled:cursor-not-allowed disabled:opacity-45',
      )}
    >
      <RSwitch.Thumb className="block h-3 w-3 touch:h-4 touch:w-4 translate-x-0.5 rounded-full bg-muted transition-transform data-[state=checked]:translate-x-[15px] touch:data-[state=checked]:translate-x-[22px] data-[state=checked]:bg-white" />
    </RSwitch.Root>
  );
}
